<template>
  <div class="page block">
    <div class="page__wrapper block-wrapper">
      <div class="page__header">
        <div class="page__title">
          <Title>{{$t($route.meta.title)}}</Title>
        </div>
      </div>
      <div class="page__body">
        <Success/>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/titles/Title'
import Success from '@/components/success/Success'
import SuccessController from './success-controller'

import {VIEWS} from '@/views/names'

export default {
  name: VIEWS.servicing.name,
  mixins: [SuccessController],
  components: {
    Title,
    Success
  }
}
</script>
